import { orderDomainStore } from '../../store';
import { isStandardOrder } from '../../utils/order-type-utils';
import { getOrder } from './get-order';
export const getOrderSiteId = () => {
    var _a;
    const order = getOrder();
    if (order && !isStandardOrder(order))
        return undefined;
    return (_a = order === null || order === void 0 ? void 0 : order.siteId) !== null && _a !== void 0 ? _a : orderDomainStore.data.selections.siteId;
};
//# sourceMappingURL=get-order-site-id.js.map